// index.js 또는 App.js 최상단
import 'odometer/themes/odometer-theme-default.css';
// src/App.js
import React, { useEffect } from 'react';
import { useLocation, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';

import { UserProvider } from './store/UserProvider';

// Scroll Top
import ScrollTop from './components/ScrollTop';

// 헤더 컴포넌트
import Header from './components/Header';
import HeaderMobile from './components/mobile/Header';
import Banner from './components/Banner';
// 푸터 컴포넌트
import Footer from './components/Footer';
import FooterMobile from './components/mobile/Footer';
// 메인 페이지
import MainPage from './components/MainPage';
import MainPageMobile from './components/mobile/MainPage';
import NewMainPage from './components/NewMainPage';
import NewMainPageMobile from './components/mobile/NewMainPage';

// About Us
import AboutUs from './components/AboutUs';
import AboutUsMobile from './components/mobile/AboutUs';
// QR - Redirect 
import QRRedirect from './components/QRRedirect';
// 이용약관
import TermsOfService from './components/TermsOfService';
// 개인정보처리방침
import PrivacyPolicy from './components/PrivacyPolicy';

// 뮤지카드 목록
import MusicardList from './components/Musicard/MusicardList';
import MusicardListMobile from './components/Musicard/mobile/MusicardList';
// 뮤지카드 상세
import MusicardDetail from './components/Musicard/MusicardDetail';
import MusicardDetailMobile from './components/Musicard/mobile/MusicardDetail';
// 뮤지카드 프리뷰
import MusicardPreview from './components/Musicard/mobile/MusicardPreview';

// 로그인
import Login from './components/User/Login';
import LoginMobile from './components/User/mobile/Login';
// 회원가입
import Signup from "./components/User/Signup";
import SignupMobile from './components/User/mobile/Signup';
// 비밀번호 재설정
import ForgotPassword from "./components/User/ForgotPassword";
import ForgotPasswordMobile from './components/User/mobile/ForgotPassword';
// 구글로그인 개인정보 동의
import GoogleConsentPage from "./components/User/GoogleConsentPopup";

// 마이 페이지
import MyPage from './components/User/MyPage';
import MyPageMobile from './components/User/mobile/MyPage';
// 마이 페이지 - 포트폴리오
import Portfolio from './components/User/Portfolio';
import PortfolioMobile from './components/User/mobile/Portfolio';
import PDFViewer from './components/User/PDFViewer';
// 마이 페이지 - 뮤직카드 목록
import MusicardPage from './components/User/MusicardPage';
import MusicardPageMobile from './components/User/mobile/MusicardPage';
// 마이 페이지 - 뮤직카드 추가
import MusicardAddPage from './components/User/MusicardAddPage';
import MusicardAddPageMobile from './components/User/mobile/MusicardAddPage';
import MusicardCreatePage from './components/User/MusicardCreatePage';

// 마이 페이지 - 뮤지카드 수정
import MusicardEditPage from "./components/User/MusicardEditPage";
import MusicardEditPageMobile from './components/User/mobile/MusicardEditPage';
// 마이 페이지 - 뮤지카드 아카이브 목록
import ArchiveList from './components/User/ArchiveList';
import ArchiveListMobile from './components/User/mobile/ArchiveList';
// 마이 페이지 - 뮤지카드 아카이브 추가/수정
import ArchiveDetail from './components/User/ArchiveDetail';
import ArchiveDetailMobile from './components/User/mobile/ArchiveDetail';
import ImportAlbum from './components/User/ImportAlbum';
import PushAlbum from './components/User/PushAlbum';
// 마이 페이지 - 뮤지카드 액티비티 목록
import ActivityList from './components/User/ActivityList';
import ActivityListMobile from './components/User/mobile/ActivityList';
// 마이 페이지 - 뮤지카드 액티비티 추가/수정
import ActivityDetail from './components/User/ActivityDetail';
import ActivityDetailMobile from './components/User/mobile/ActivityDetail';
import PushActivity from './components/User/PushActivity';
import ImportActivity from './components/User/ImportActivity';
import ImportStages from './components/User/ImportStages';
import ImportEvents from './components/User/ImportEvents';
// 마이 페이지 - 뮤지카드 포지션 & 스킬 목록
import PositionsList from './components/User/PositionsList';
import PositionsListMobile from './components/User/mobile/PositionsList';
// 마이 페이지 - 뮤지카드 포지션 & 스킬 추가/수정
import PositionsDetail from './components/User/PositionsDetail';
import PositionsDetailMobile from './components/User/mobile/PositionsDetail';
import PushPosition from './components/User/PushPosition';
import SourceSelector from './components/User/SourceSelector';
// 마이 페이지 - 뮤지카드 멤버 목록
import MembersList from './components/User/MembersList';
import MembersListMobile from './components/User/mobile/MembersList';
// 마이 페이지 - 뮤지카드 멤버 추가/수정
import MembersDetail from './components/User/MembersDetail';
import MembersDetailMobile from './components/User/mobile/MembersDetail';
import PushMember from './components/User/PushMember';
import MusicardSelector from './components/User/MusicardSelector';
// 마이 페이지 - 뮤지카드 연락처 목록
import ContactList from './components/User/ContactList';
import ContactListMobile from './components/User/mobile/ContactList';
// 마이 페이지 - 뮤지카드 연락처 추가/수정
import ContactDetail from './components/User/ContactDetail';
import ContactDetailMobile from './components/User/mobile/ContactDetail';
import PushContact from './components/User/PushContact';


function App() {
  const mobileView  = isMobile && !isTablet ? true : false;
  const tabletView  = isTablet ? true : false;
  
  // 페이지 렌더링 이후 #root main 최소 높이 변경
  useEffect(() => { resizeHeight(); }, []);

  const resizeHeight = () => {
    const mainComponent   = document.querySelector('#root main');
    const headerComponent = document.querySelector('#root header');
    const footerComponent = document.querySelector('#root footer');
    if (mainComponent && headerComponent && footerComponent) {
      mainComponent.style.minHeight = `calc(100vh - ${headerComponent.offsetHeight}px - ${footerComponent.offsetHeight}px)`;
    }
  }
  
  // 스크린 사이즈 변경 시 #root main 높이 변경
  window.addEventListener("resize", () => { resizeHeight(); });
  
  const host = window.location.host;
  const production = host.includes('localhost') || host.includes(':3000') ? false : true;

  const hideHeaderFooter = window.location.pathname.startsWith('/pdf-viewer');
  const isPreview = window.location.pathname.startsWith('/preview');
  
  
  return (
    <Router>
      {/* 유저 로그인 세션 확인 Context */}
      <UserProvider>
        <ScrollTop />
        {/* 헤더 */}
        {!isPreview && (hideHeaderFooter ? <Banner /> : (mobileView ? <HeaderMobile /> : <Header />))}

        {/* 메인 콘텐츠 */}
        <main className={mobileView ? 'mobileMain' : ''}>
        <Routes>
          {/* 메인 페이지 */}
          <Route path="/" element={ !mobileView ? <NewMainPage /> : <NewMainPageMobile /> } />
          {/*!production && ( <Route path="/temp" element={!mobileView ? <NewMainPage /> : <MainPageMobile />} />  */}
          {/* About Us */}
          <Route path="/about-us" element={ !mobileView ? <AboutUs /> : <AboutUsMobile />} />
          {/* Musicard 관련 페이지 */}
          <Route path="/musicard" element={ !mobileView ? <MusicardList /> : <MusicardListMobile /> } />
          {/* 뮤지카드 페이지 */}
          <Route path="/musicard/:id" element={ !mobileView ? <MusicardDetail isTablet={ tabletView } /> : <MusicardDetailMobile /> } />
          <Route path="/musicard/:id/:menu" element={ !mobileView ? <MusicardDetail isTablet={ tabletView } /> : <MusicardDetailMobile /> } />
          {/* 뮤지카드 프리뷰 */}
          <Route path="/preview/:id" element={<MusicardPreview />} />
          {/* QR 코드 리디렉션 */}
          <Route path="/qr/:musicianId" element={<QRRedirect />} />
          {/* 이용약관 */}
          <Route path="/TermsOfService" element={<TermsOfService />} />
          {/* 개인정보처리방침 */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          {/* 로그인 */}
          <Route path="/login" element={ !mobileView ? <Login /> : <LoginMobile /> } />
          {/* 회원가입 */}
          <Route path="/signup" element={ !mobileView ? <Signup /> : <SignupMobile /> } />
          {/* 구글로그인 개인정보 동의 페이지 */}
          <Route path="/google-consent" element={<GoogleConsentPage />} />
          {/* 비밀번호 재설정 */}
          <Route path="/forgot-password" element={ !mobileView ? <ForgotPassword /> : <ForgotPasswordMobile /> } />
          {/* 마이 페이지 - 포트폴리오 pdf 뷰어 */}
          <Route path="/pdf-viewer" element={<PDFViewer />} />
          {/* 마이 페이지 */}
          <Route path="/my-page" element={ !mobileView ? <MyPage /> : <MyPageMobile /> } />
          {/* 마이 페이지 - 포트폴리오 */}
          <Route path="/my-page/portfolio" element={ !mobileView ? <Portfolio /> : <PortfolioMobile /> } />
          {/* 마이 페이지 - 보유 뮤지카드 목록 */}
          <Route path="/my-page/musicard" element={ !mobileView ? <MusicardPage /> : <MusicardPageMobile /> } />
          {/* 마이 페이지 - 뮤지카드 추가 */}
          <Route path="/my-page/musicard/add" element={ !mobileView ? <MusicardAddPage /> : <MusicardAddPageMobile /> } />
          {/* 마이 페이지 - 뮤지카드 추가 NEW */}
          <Route path="/my-page/musicard/create" element={ !mobileView ? <MusicardCreatePage /> : <MusicardCreatePage /> } />
          {/* 마이 페이지 - 뮤지카드 스타일 수정 페이지 */}
          <Route path="/my-page/musicard/:musicardID" element={ !mobileView ? <MusicardEditPage /> : <MusicardEditPageMobile /> } />
          {/* 마이 페이지 - 뮤지카드 스타일 수정 페이지 */}
          <Route path="/my-page/musicard/:musicardID/source-selector" element={<SourceSelector />} />
          {/* 마이 페이지 - 아카이브 앨범 목록 */}
          <Route path="/my-page/archive/:attribute/" element={ !mobileView ? <ArchiveList /> : <ArchiveListMobile /> } />
          {/* 마이 페이지 - 앨범 설명 및 트랙 수정 페이지 */}
          <Route path="/my-page/archive/:attribute/:albumID" element={ !mobileView ? <ArchiveDetail /> : <ArchiveDetailMobile /> } />
          {/* 마이 페이지 - 앨범 가져오기 */}
          <Route path="/my-page/archives/released/import" element={<ImportAlbum />} />
          {/* 마이 페이지 - 뮤지카드에 추가하기 */}
          <Route path="/my-page/archive/:attribute/push" element={<PushAlbum />} />
          {/* 마이 페이지 - 포지션 & 스킬 목록 */}
          <Route path="/my-page/position-skill" element={ !mobileView ? <PositionsList /> : <PositionsListMobile /> } />
          {/* 마이 페이지 - 포지션 & 스킬 추가/수정 */}
          <Route path="/my-page/position-skill/:positionId" element={ !mobileView ? <PositionsDetail /> : <PositionsDetailMobile /> } />
          {/* 마이 페이지 - 포지션 & 스킬 */}
          <Route path="/my-page/position-skill/:positionId/source-selector" element={<SourceSelector />} />
          {/* 마이 페이지 - 포지션 & 스킬 */}
          <Route path="/my-page/position-skill/push" element={<PushPosition />} />
          {/* 마이 페이지 - 멤버 */}
          <Route path="/my-page/members" element={ !mobileView ? <MembersList /> : <MembersListMobile /> } />
          {/* 마이 페이지 - 멤버 */}
          <Route path="/my-page/members/:memberID" element={ !mobileView ? <MembersDetail /> : <MembersDetailMobile />} />
          {/* 마이 페이지 - 멤버 */}
          <Route path="/my-page/members/push" element={<PushMember />} />
          {/* 마이 페이지 - 멤버 */}
          <Route path="/my-page/members/:memberID/source-selector" element={<SourceSelector />} />
          {/* 마이 페이지 - 멤버 */}
          <Route path="/my-page/members/:memberID/musicard-selector" element={<MusicardSelector />} />
          {/* 마이 페이지 - 액티비티 */}
          <Route path="/my-page/activity" element={ !mobileView ? <ActivityList /> : <ActivityListMobile />} />
          {/* 마이 페이지 - 액티비티 */}
          <Route path="/my-page/activity/:activityID" element={ !mobileView ? <ActivityDetail /> : <ActivityDetailMobile />} />
          {/* 마이 페이지 - 액티비티 */}
          <Route path="/my-page/activity/push" element={<PushActivity />} />
          {/* 마이 페이지 - 액티비티 가져오기 */}
          <Route path="/my-page/activity/import" element={<ImportActivity />} />
          {/* 마이 페이지 - 액티비티 가져오기 */}
          <Route path="/my-page/activity/importStages" element={<ImportStages />} />
          {/* 마이 페이지 - 액티비티 가져오기 */}
          <Route path="/my-page/activity/importEvents" element={<ImportEvents />} />
          {/* 마이 페이지 - 컨텍트 */}
          <Route path="/my-page/contact" element={ !mobileView ? <ContactList /> : <ContactListMobile /> } />
          {/* 마이 페이지 - 컨텍트 */}
          <Route path="/my-page/contact/:contactId" element={ !mobileView ? <ContactDetail /> : <ContactDetailMobile /> } />
          {/* 마이 페이지 - 컨텍트 */}
          <Route path="/my-page/contact/push" element={<PushContact />} />
        </Routes>
        </main>

        {/* 푸터 */}
        {
          !isPreview && !hideHeaderFooter && ( !mobileView ? <Footer /> : <FooterMobile /> )
        }
      </UserProvider>
    </Router>
  );
}

export default App;